import { Link } from "react-router-dom";

// Available modifiers: --primary; --secondary;
// See _buttons.scss

function CTAButton({
   children,
   modifier,
   destination,
   htmlTag,
   target,
   openURL,
}) {
   return (
      <>
         {htmlTag === "link" ? (
            <Link to={destination} className={`btn btn--${modifier}`}>
               {children}
            </Link>
         ) : (
            <button
               className={`btn btn--${modifier}`}
               onClick={() => {
                  return openURL ? window.open(openURL, target) : "";
               }}
            >
               {children}
            </button>
         )}
      </>
   );
}

export default CTAButton;
